import { sort_children, bigScreen_sort_children, app_sort_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxSort = {
  name: "cxSort",
  desc: "用于对图文列表、数据列表等组件进行排序",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "排序",
        children: app_sort_children,
        group: "highLevel",
        sort: 100,
        enable: true
      }
    ],
    bigScreen: [
      {
        name: "排序",
        children: bigScreen_sort_children,
        group: "highLevel",
        sort: 50,
        enable: false
      }
    ],
    portal: [
      {
        name: "排序",
        children: sort_children,
        group: "highLevel",
        sort: 100,
        enable: true
      }
    ]
  },
  toolbars: [
    {
      name: "cxSort",
      label: "排序",
      comp: {
        sortComponentData: () => import("./toolbars/sort-options-data.vue"),
        sortComponentSetting: () => import("./toolbars/sort-options-setting.vue"),
        sortComponentConfig: () => import("./toolbars/sort-options-config.vue")
      }
    }
  ]
}

export default cxSort